<template>
  <div class="survey-questions-counter" :style="style">
    <div
      v-for="(_, idx) in Array(total).fill('')"
      class="counter-marker"
      :key="idx + 1"
      :class="{ colored: current >= idx }"
    />
  </div>
</template>

<script>
export default {
  props: {
    total: {
      type: Number,
      default: 0
    },
    current: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      style: {
        gridTemplateColumns: `repeat(${this.total}, 1fr)`
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.survey-questions-counter {
  gap: 16px;
  width: 100%;
  display: grid;
  align-items: center;

  .counter-marker {
    width: 100%;
    height: 8px;
    border-radius: 8px;
    background-color: $neutral-048;
    transition: 0.2s background-color;
    &.colored {
      background-color: $primary-300;
    }
  }
}
</style>
